import { getQueryParamsString } from 'services/queryParamsService';
import queryString from 'query-string';

const { stringify } = queryString;

const BELIVE_SITE_HOST = process.env.REACT_APP_BELIVE_SITE_HOST;

const API_HOST = process.env.REACT_APP_BELIVE_API_HOST;

function getApiHost() {
  return API_HOST;
}

export const getHomePageUrl = () => `https://${BELIVE_SITE_HOST}`;

// User section
export const getUserProfileUrl = () => `https://${getApiHost()}/profile`;
export const getUserMeApiUrl = () => `https://${getApiHost()}/api/me.json`;
export const getUserExperimentGroupUrl = () => `https://${getApiHost()}/api/me/experiment_group`;

// Pricing page and payment section
export const getPricingPageUrl = () => `https://${getApiHost()}/packages_module`;
export const getPackagesApiUrl = () => `https://${getApiHost()}/api/packages.json`;
export const getFastspringOrderUrl = (orderId) =>
  `https://${getApiHost()}/payments/fastspring_order?order_id=${orderId}`;
export const getFastspringSessionUrl = (params) =>
  `https://${getApiHost()}/payments/fastspring_session?${stringify(params)}`;
export const getFastspringCheckPaymentUrl = (userId) =>
  `https://${getApiHost()}/payments/check_payment?user_id=${userId}`;
export const getChangePlanUrl = (params) =>
  `https://${getApiHost()}/subscriptions/change_payment_plan?${stringify(params)}`;
export const getFlexibleTokenUrl = (planId, isAnnuallyPlan) =>
  `https://${getApiHost()}/payments/flexible_token?plan=${planId}&is_yearly=${isAnnuallyPlan}${getQueryParamsString()}`;

// Sign in and Start trial section
export const getSignInUrl = () => `https://${getApiHost()}/#signin`;
export const getStartTrialUrl = (planId) =>
  `https://${getApiHost()}/start?plan_id=${planId}&start_trial=true${getQueryParamsString()}`;
export const getRemoteAssistantStartUrl = () =>
  `https://${getApiHost()}/start?start_trial=true&custom_landing=remote-assistant`;
export const getAppsumoStartUrl = (promo) =>
  `https://${getApiHost()}/start?custom_landing=appsumo&promo=${promo}`;
export const getKalturaAuthUrl = () => `https://${getApiHost()}/auth/email?custom_landing=kaltura`;

// Other section
export const getTosUrl = () => `https://${getApiHost()}/tos`;
export const getPrivacyUrl = () => `https://${getApiHost()}/privacy`;
